import NavbarMenu from "Components/Navbar/NavbarMenu";
import SidbarMenu from "Components/Sidbar/SidbarMenu";
import Cookies from "js-cookie";
import Pusher from "pusher-js";
import audio from "../../assets/iPHONE.mp3";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useNavigate, useOutlet } from "react-router-dom";
import axiosInstance from "../../axios";
import { toast } from "react-toastify";
import { getToken, onMessage } from "firebase/messaging";
import { messaging, setupNotifications } from "../../firebase";
import useVisibilityChange from "useVisibilityChange";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faTwitter, faYoutube,faTiktok,faWhatsapp,faInstagram } from "@fortawesome/free-brands-svg-icons";
import { useTranslation } from "react-i18next";
import logoFooter from "../../assets/LandingPageImages/logo/logo.png";


const Layout = () => {
  const token = useSelector((state) => state.auth.token);
const {t}=useTranslation()
  const userId = useSelector((state) => state.auth.userId);
  const router = useNavigate();
  const soundEffect = useRef(null);
  const outlet = useOutlet();

const Authentecated=useSelector((state)=>state.auth.isAuthenticated)
useEffect(()=>{
  if(!Authentecated){
    router("/loginForm")
  }
},[Authentecated])


  return (
    <div className="d-flex">
      <SidbarMenu isOpen={undefined} closeToggleSidebar={undefined} />

      <div className="contnet-page">
        <NavbarMenu />
        <audio ref={soundEffect} src={audio}></audio>
        <div className="px-3" style={{ paddingBottom: "100px" }}>
          <Outlet /> 
        </div>
 
      </div>
    </div>
  );
};

export default Layout;
